export const FIT_MODES = ['contain', 'cover', 'fill'];

export const FIT_LABELS = {
  contain: 'FIT',
  cover: 'CROP',
  fill: 'STRETCH',
};

export const FIT_DESCRIPTIONS = {
  contain: 'Fit - full frame, bars visible',
  cover: 'Crop - fills container, edges trimmed',
  fill: 'Stretch - distorts to fill container',
};

export const STARTUP_PLAY_DELAY_MS = {
  autoplay: 2200,
  manual: 1800,
};

export const WATCHTIME_CUTOFF_WARNING_MS = 10 * 1000;
export const MAX_VIDEO_READY_WAIT_MS = 10000;
export const MIN_READY_VIDEO_SECONDS = 1.5;
export const VIDEO_READY_CHECK_INTERVAL_MS = 250;
export const VIDEO_START_FAILURE_TIMEOUT_MS = 12000;
export const RECOVERY_GRACE_MS = 10000;
export const RETRY_BACKOFF_MS = [1500, 3000, 5000, 8000, 12000];
export const DEFAULT_VIDEO_VOLUME = 1;

export const PLAYBACK_STATUS = {
  idle: 'idle',
  starting: 'starting',
  playing: 'playing',
  paused: 'paused',
  recovering: 'recovering',
  blocked: 'blocked',
};

export const hlsConfig = {
  enableWorker: true, // Offloads some of the video processing to a web worker, which can improve performance and reduce main thread blocking
  lowLatencyMode: false, // Adds latency (few seconds behind live) but keeps the video more stable by waiting for full segments
  liveSyncDurationCount: 3, // Keeps playback around 3 segment durations behind the newest segment available in the live playlist.
  // Uses HLS.js default max live latency (Infinity) so intentional rewinds are not forced back to live.
  backBufferLength: 30, // Number of seconds of already watched video to keep in memory behind current position
  liveDurationInfinity: true, // Treats live stream duration as Infinity instead of a fixed duration.
  xhrSetup: (xhr) => {
    xhr.withCredentials = true; // Includes auth credentials in the request for the video stream from the backend when using HLS.js
  },
};
